import { modalType } from '../../util/ModalUtil';
import { useDispatch } from 'react-redux';
import { useState, useEffect, useRef } from 'react';
import CodeUtil from '../../util/CodeUtil';
import { CODE_GROUP_ID, ROLE } from '../../constant/Constant';
import { InfoTxt, ModalHeader } from '../../component/ModalRef';
import SelectionBox from '../../component/SelectionBox';
import InputBox from '../../component/InputBox';
import { actionUserAdd, actionUserEdit, actionUserPwreset } from '../../module/body/system/SystemUserModule';
import CancelButtonBox from '../../component/buttons/CancelButtonBox';
import ConfirmButtonBox from '../../component/buttons/ConfirmButtonBox';
import PopupRef from '../../component/PopupRef';
import TelNoInputBox from '../../component/TelNoInputBox';
import NullCheckUtil from '../../util/NullCheckUtil';

const SystemUserModal = ({ type, modalRef, row, callback }) => {
    const dispatch = useDispatch();
    const popupRef = useRef(null);

    const [userUniversityCd, setUserUniversityCd] = useState();
    const [userId, setUserId] = useState();
    const [pswd, setPswd] = useState();
    const [userRoleCd, setUserRoleCd] = useState();
    const [userNm, setUserNm] = useState();
    const [email, setEmail] = useState();
    const [telNo, setTelNo] = useState();
    const [validIp, setValidIp] = useState();

    useEffect(() => {
        if (type == modalType.ADD) {
            setUserRoleCd(CodeUtil.getFirstCode('USER_ROLE'));
            setUserUniversityCd(CodeUtil.getFirstCode(CODE_GROUP_ID.USER_UNIVERSITY));
        } else {
            row && setUserUniversityCd(row.userUniversityCd);
            row && setUserId(row.userId);
            row && setUserNm(row.userNm);
            row && setEmail(row.email);
            row && setTelNo(row.telNo);
            row && setUserRoleCd(row.userRoleCd);
            row && setValidIp(row.validIp);
        }
    }, []);

    const handleCancel = () => {
        modalRef.current.close();
    };

    const setUniversityCdEmptyIfAdmin = (roleCd) => {
        if (roleCd == 'ADMIN') {
            return '';
        } else {
            return userUniversityCd;
        }
    };

    const validateData = () => {
        if (NullCheckUtil.isEmpty(userId)) {
            popupRef.current.openAlert('ID를 입력해주세요.');
            return false;
        }

        if (NullCheckUtil.isEmpty(userNm)) {
            popupRef.current.openAlert('이름을 입력해주세요.');
            return false;
        }

        if (type == modalType.ADD && NullCheckUtil.isEmpty(pswd)) {
            popupRef.current.openAlert('비밀번호를 입력해주세요.');
            return false;
        }

        if (NullCheckUtil.isEmpty(email)) {
            popupRef.current.openAlert('이메일을 입력해주세요.');
            return false;
        } else if (email.includes(':')) {
            popupRef.current.openAlert('이메일에는 콜론(:) 문자를 포함할 수 없습니다.');
            return false;
        }

        if (NullCheckUtil.isEmpty(telNo)) {
            popupRef.current.openAlert('휴대전화 번호를 입력해주세요.');
            return false;
        }

        return true;
    };

    const handleConfirm = () => {
        if (validateData()) {
            type == modalType.ADD
                ? dispatch(
                      actionUserAdd({
                          data: {
                              userUniversityCd: setUniversityCdEmptyIfAdmin(userRoleCd),
                              userId,
                              pswd: btoa(pswd),
                              userNm,
                              email,
                              telNo,
                              userRoleCd,
                              userRegValidStatusCd: 'WAITING',
                              validIp,
                          },
                          callback: (params) => {
                              popupRef.current.openInfo(
                                  '사용자 ' + params.userNm + '의 정보가 등록되었습니다. ',
                                  () => {
                                      return function () {
                                          modalRef.current.close();
                                      };
                                  },
                              );
                              callback();
                          },
                      }),
                  )
                : dispatch(
                      actionUserEdit({
                          data: { userUniversityCd, userId, userNm, email, telNo, userRoleCd, validIp },
                          callback: () => {
                              popupRef.current.openInfo('사용자 ' + userNm + '의 정보가 수정되었습니다.', () => {
                                  return function () {
                                      modalRef.current.close();
                                  };
                              });
                              callback();
                          },
                      }),
                  );
        }
    };

    const sendPasswordResetMail = (e) => {
        dispatch(
            actionUserPwreset({
                data: { userUniversityCd, userId, userNm, email, telNo },
                callback: () => {
                    popupRef.current.openInfo(email + '로 비밀번호 초기화 메일이 발송되었습니다.');
                },
            }),
        );
    };

    // 타이틀 관련 수정 명확하도록 외부 변수로 처리 필요
    return (
        <>
            <ModalHeader title={type == modalType.ADD ? '사용자 등록' : '사용자 수정'} modalRef={modalRef} />
            <div className='modal-body'>
                <div className='con-inner'>
                    <InfoTxt
                        infoTxt={type == modalType.ADD ? '사용자 정보를 등록합니다.' : '사용자 정보를 수정합니다.'}
                    />
                    <div>
                        <div className='form-box-row'>
                            <InputBox
                                title='ID'
                                value={userId}
                                disabled={type == modalType.EDIT}
                                onChange={(e) => setUserId(e.target.value)}
                            />
                        </div>
                        <div className='form-box-row'>
                            <InputBox title='이름' value={userNm} onChange={(e) => setUserNm(e.target.value)} />
                            {type == modalType.ADD && (
                                <InputBox
                                    title='비밀번호'
                                    value={pswd}
                                    password
                                    onChange={(e) => setPswd(e.target.value)}
                                />
                            )}
                            {type == modalType.EDIT && (
                                <button
                                    type='button'
                                    className='btn blue-border'
                                    style={{ width: '160px' }}
                                    onClick={(e) => sendPasswordResetMail(e)}
                                >
                                    {'비밀번호 초기화'}
                                </button>
                            )}
                        </div>
                        <div className='form-box-row'>
                            <SelectionBox
                                title='역할'
                                options={CodeUtil.getCodes(CODE_GROUP_ID.USER_ROLE)}
                                value={userRoleCd}
                                disabled={type == modalType.EDIT}
                                onChange={(e) => setUserRoleCd(e.target.value)}
                                useAll={false}
                            />
                            {userRoleCd != 'ADMIN' && (
                                <SelectionBox
                                    title='대학'
                                    options={
                                        userRoleCd == ROLE.STUDENT
                                            ? CodeUtil.getCodes(CODE_GROUP_ID.USER_UNIVERSITY)
                                            : CodeUtil.getCodes(CODE_GROUP_ID.MAIN_UNIVERSITY)
                                    }
                                    value={userUniversityCd}
                                    disabled={type == modalType.EDIT}
                                    onChange={(e) => setUserUniversityCd(e.target.value)}
                                    useAll={false}
                                />
                            )}
                        </div>
                        <div className='form-box-row'>
                            <InputBox title='이메일' value={email} onChange={(e) => setEmail(e.target.value)} />
                            <TelNoInputBox title='연락처' value={telNo} setTelNo={setTelNo} />
                        </div>
                        <div className='form-box-row'>
                            <InputBox title='유효IP주소' value={validIp} onChange={(e) => setValidIp(e.target.value)} />
                        </div>
                    </div>
                </div>
                <div className='modal-btn-wrap'>
                    <CancelButtonBox title='취소' onClick={(e) => handleCancel()} />
                    <ConfirmButtonBox title='확인' onClick={(e) => handleConfirm()} />
                </div>
            </div>
            <PopupRef ref={popupRef} />
        </>
    );
};

export default SystemUserModal;
